import React, { useEffect } from 'react';
import { RecoilRoot } from 'recoil';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import './App.css';
import { PrivateRoute } from './configs/helpers/PrivateRoute';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import { useDarkMode } from './configs/ui/theme';
import Login from './views/Login/Login';
import Logout from './views/Logout/Logout';
import Main from './views/Main';
import OktaAuth, { toRelativeUrl } from '@okta/okta-auth-js';
import { LoginCallback, Security } from '@okta/okta-react';
import history from './configs/helpers/history';
import LoadingFullScreen from './components/Loading/LoadingFullScreen';
import Callback from './views/Callback/Callback';
import LoginUsername from './views/Login/LoginUsername';

const oktaAuth = new OktaAuth({
   issuer: process.env.REACT_APP_OKTA_ISSUER,
   clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
   redirectUri: window.location.origin + '/okta-callback',
});

function App() {
   const [theme, toggleDarkMode] = useDarkMode();
   const themeConfig = createMuiTheme(theme);
   const clearCache = () => {
      let APP_VERSION = localStorage.getItem('APP_VERSION');
      if (APP_VERSION !== process.env.REACT_APP_DISPLAY_VERSION) {
         localStorage.setItem(
            'APP_VERSION',
            process.env.REACT_APP_DISPLAY_VERSION,
         );
         window.location.reload(true);
      }
   };
   useEffect(() => {
      clearCache();
   }, []);

   const restoreOriginalUri = (_oktaAuth, originalUri) => {
      window.location.replace(
         toRelativeUrl(originalUri || '/callback', window.location.origin),
      );
   };

   const onAuthRequired = function () {
      history.push('/login');
   };

   return (
      <RecoilRoot>
         <ThemeProvider theme={themeConfig}>
            <SnackbarProvider maxSnack={3}>
               <CssBaseline />
               <Security
                  oktaAuth={oktaAuth}
                  restoreOriginalUri={restoreOriginalUri}
                  onAuthRequired={onAuthRequired}
               >
                  <Router history={history}>
                     <Route
                        exact
                        path='/'
                        component={(props) => (
                           <Login {...props} onToggleDark={toggleDarkMode} />
                        )}
                     />
                     <Route
                        path='/login'
                        component={(props) => (
                           <Login {...props} onToggleDark={toggleDarkMode} />
                        )}
                     />
                     <Route
                        path='/login-username'
                        component={(props) => (
                           <LoginUsername
                              {...props}
                              onToggleDark={toggleDarkMode}
                           />
                        )}
                     />
                     <Route
                        path='/callback'
                        component={(props) => <Callback />}
                     />
                     <Route path='/logout' component={Logout} />
                     <Route
                        path='/okta-callback'
                        render={() => (
                           <LoginCallback
                              loadingElement={<LoadingFullScreen />}
                           />
                        )}
                     />
                     <PrivateRoute
                        path='/private'
                        component={(props) => (
                           <Main {...props} onToggleDark={toggleDarkMode} />
                        )}
                     />
                  </Router>
               </Security>
            </SnackbarProvider>
         </ThemeProvider>
      </RecoilRoot>
   );
}
export default App;
